import JSZip from 'jszip';
import React, { useState, useEffect } from 'react';

import { Select, Label } from '@iq/react-components';

const VALID_EXTS = new Set(['sldasm', 'rvt', 'iam', 'dgn', 'obj']);

const SelectRootFile = ({ onSelect, file, onInvalidFile }) => {
  const [rootFiles, setRootFiles] = useState([]);

  useEffect(() => {
    if (!file) return;
    const asyncUnzip = async () => {
      const zip = JSZip();
      try {
        await zip.loadAsync(file);
      } catch {
        onInvalidFile();
        return;
      }
      const roots = Object.keys(zip.files).filter((filename) =>
        VALID_EXTS.has(filename.split('.').pop().toLowerCase())
      );

      if (roots.length > 0) {
        setRootFiles(roots);
      } else {
        onInvalidFile();
      }
    };
    asyncUnzip();
  }, [file, onInvalidFile]);

  return (
    <div className="field">
      <Label htmlFor="select-root-file">
        Select root file
        <span title="Field is required"> *</span>
      </Label>
      <Select
        id="select-root-file"
        onChange={(event) => onSelect(event.value || null)}
        options={rootFiles.map((f) => ({ value: f, label: f }))}
        required
      />
    </div>
  );
};

export default SelectRootFile;
